import initialState from '../app/initialstate';

const SET_IS_MODAL_OPEN = 'app/modal/open';

export default function modalOpenStateReducer(state = initialState.isModalOpen, action) {
	switch (action.type) {
		case SET_IS_MODAL_OPEN: {
			return action.isModalOpen;
		}
		default:
			return state;
	}
}

export function setIsModalOpen(isModalOpen) {
	return {
		type: SET_IS_MODAL_OPEN,
		isModalOpen
	};
}
